import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9i4twtz8: FaireBrandEntity = {
  token: "b_9i4twtz8",
  type: "brand",
  name: "WOLL",
  avatarUrl:
    "https://cdn.faire.com/fastly/353784e33d079c098a157ec67e4ca3b354e4d75b174bfd91b8b2a0826936753b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4fcf386bf7af16e6deb7b8b2a5c8efccfed53d2e629f344d83cc56d96d698ba1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/353784e33d079c098a157ec67e4ca3b354e4d75b174bfd91b8b2a0826936753b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4fcf386bf7af16e6deb7b8b2a5c8efccfed53d2e629f344d83cc56d96d698ba1.jpeg",
  location: "Santa Cruz, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "WOLL is a california-based jewelry and accessories brand. We create colorful, lightweight pieces using mainly Italian acetate and acrylic. Our attention is on design and quality and you can expect each of our pieces to bring the wearer a little bit of joy! We are proud to say that WOLL is made here in the USA.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:32.440Z",
    importedBy: "entity-db-cli",
  },
};
